import React from "react";
import { Logo } from "../Navigation";

const COLS = [
  {
    title: "Platform",
    links: [
      { label: "F3 Discover", href: "#platform" },
      { label: "F3 Engage", href: "#platform" },
      { label: "F3 Monetize", href: "#platform" },
      { label: "Solutions", href: "#solutions" },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "About", href: "#about" },
      { label: "Insights", href: "#insights" },
      { label: "Why F3", href: "#why-f3" },
      { label: "Market", href: "#market" },
    ],
  },
  {
    title: "Connect",
    links: [
      { label: "Creators", href: "mailto:info@f3mediainc.com?subject=Creator Partnership" },
      { label: "Brands", href: "mailto:info@f3mediainc.com?subject=Brand Partnership" },
      { label: "Investors", href: "mailto:info@f3mediainc.com?subject=Investor Inquiry" },
      { label: "Press", href: "mailto:info@f3mediainc.com?subject=Press Inquiry" },
    ],
  },
];

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-white/10 pt-16 pb-10 bg-black"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Manifesto strip */}
        <div className="mb-16">
          <div className="text-[11px] font-mono uppercase tracking-[0.3em] text-violet-300 mb-4">
            Manifesto
          </div>
          <div className="font-serif-display text-3xl md:text-5xl lg:text-6xl tracking-tight text-white leading-[1.1]">
            F3 Media —{" "}
            <span className="font-normal text-zinc-400">
              Signal over noise
            </span>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-12 gap-10 mb-12">
          <div className="col-span-2 md:col-span-5">
            <Logo />
            <p className="mt-5 text-sm text-zinc-400 leading-relaxed max-w-sm">
              The premium AI-powered media ecosystem for news, knowledge and
              current affairs. Headquartered in the USA. Remote-first.
            </p>
            <div className="mt-6 flex items-center gap-2 text-[11px] font-mono uppercase tracking-[0.25em] text-zinc-400">
              <span className="text-zinc-600">Email ·</span>
              <a
                href="mailto:info@f3mediainc.com"
                data-testid="footer-bio-email"
                className="hover:text-white transition-colors normal-case tracking-normal"
              >
                info@f3mediainc.com
              </a>
            </div>
          </div>

          {COLS.map((col) => (
            <div key={col.title} className="md:col-span-2">
              <div className="text-[10px] font-mono uppercase tracking-[0.3em] text-zinc-500 mb-4">
                {col.title}
              </div>
              <ul className="space-y-2.5">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <a
                      href={l.href}
                      data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                      className="text-sm text-zinc-300 hover:text-white transition-colors"
                    >
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="col-span-2 md:col-span-1" />
        </div>

        <div className="hr-line mb-6" />
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-[11px] font-mono uppercase tracking-[0.25em] text-zinc-600">
          <div>© {new Date().getFullYear()} F3 Media Inc. All rights reserved.</div>
          <div className="flex items-center gap-6">
            <a href="#home" className="hover:text-white transition-colors">Privacy</a>
            <a href="#home" className="hover:text-white transition-colors">Terms</a>
            <a href="#home" className="hover:text-white transition-colors">Conduct</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
